var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "color1",
    d: "M1.226 6.326v2.27h4.54v2.27h-2.27a2.27 2.27 0 00-2.27 2.269v4.539H8.035v-2.27h-4.54v-2.27h2.27a2.27 2.27 0 002.27-2.269v-2.27a2.27 2.27 0 00-2.27-2.269zm7.37 0v6.809h4.539v4.539h2.27V6.326h-2.27v4.54h-2.27v-4.54zm7.369 0V17.674h2.27v-4.539h2.269v4.539h2.27v-4.537a2.27 2.27 0 00-.005-.162 2.27 2.27 0 00-.018-.162 2.27 2.27 0 00-.029-.16 2.27 2.27 0 00-.04-.157 2.27 2.27 0 00-.05-.153 2.27 2.27 0 00-.063-.15 2.27 2.27 0 00-.073-.144 2.27 2.27 0 00-.082-.14 2.27 2.27 0 00-.093-.133 2.27 2.27 0 00-.102-.126 2.27 2.27 0 00-.11-.118 2.27 2.27 0 00-.118-.11 2.27 2.27 0 00-.126-.102 2.27 2.27 0 00-.133-.094 2.27 2.27 0 00-.14-.082 2.27 2.27 0 00-.144-.073 2.27 2.27 0 00-.15-.062 2.27 2.27 0 00-.154-.05 2.27 2.27 0 00-.157-.04 2.27 2.27 0 00-.16-.03 2.27 2.27 0 00-.161-.017 2.27 2.27 0 00-.162-.005h-2.27V6.326z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH24);
export default __webpack_public_path__ + "static/media/h24.8d609458.svg";
export { ForwardRef as ReactComponent };